module.exports = __webpack_public_path__ + "img/drops.201b4a1c.svg";